// extracted by css-extract-rspack-plugin
export default {"cls1":"Carousel-cls1_K39","cls2":"Carousel-cls2_06L Carousel-cls1_K39"};